import React from 'react'
import Tabs from './Tabs'
import { walletname } from '../Wallet'
import { walletimage } from '../Wallet'

const Keyphase = () => {
  return (
    <div className='container'>
        <div className='flex items-center mb-4'>
            <div>
                <img className='w-8 h-8 mr-1' src={walletimage} alt=''></img>
                </div>
            <div>
                <h3 className='text-black'> Import your <span id="walletname">{walletname}</span> wallet</h3>
                </div>
        </div>
        <Tabs/>
       
        <div>
          
        </div>
    </div>
  )
}

export default Keyphase